import actionTypes from './actionTypes';

const initialState = {
  name: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${actionTypes.SET_NAME_TUTORIAL_ITEM}`: {
      return {
        ...state,
        name: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
